import { render, staticRenderFns } from "./ContentPreviewSettingsPluginsCustom.vue?vue&type=template&id=5672c48d&scoped=true&"
import script from "./ContentPreviewSettingsPluginsCustom.vue?vue&type=script&lang=js&"
export * from "./ContentPreviewSettingsPluginsCustom.vue?vue&type=script&lang=js&"
import style0 from "./ContentPreviewSettingsPluginsCustom.vue?vue&type=style&index=0&id=5672c48d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5672c48d",
  null
  
)

export default component.exports